import { Routes } from '@angular/router';
import {HomeComponent} from './common/UI/home-component/home-component';
import {LoginComponent} from './auth/UI/login/login-component/login-component';
import {RegisterComponent} from './auth/UI/register/register-component/register-component';
import {authGuard} from './auth/guards/auth-guard';
import {ChangePasswordComponent} from './users/UI/change-password-component/change-password-component';
import {EditProfileComponent} from './users/UI/edit-profile-component/edit-profile-component';
import {ForgotPasswordComponent} from './auth/UI/forgot-password/forgot-password-component/forgot-password-component';
import {ResetPasswordComponent} from './auth/UI/reset-password/reset-password-component/reset-password-component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: "Dymly"},
  { path: 'login', component: LoginComponent, title: "Вход" },
  { path: 'register', component: RegisterComponent, title: "Регистрация"},
  { path: 'forgot-password', component: ForgotPasswordComponent, title: "Восстановление пароля"},
  { path: 'reset-password/:token', component: ResetPasswordComponent, title: "Сброс пароля" },
  { path: 'reset-password', redirectTo: 'forgot-password' },
  { path: 'main',
    loadComponent: () => import('./feed/UI/feed-main-component/feed-main-component')
      .then(c => c.FeedMainComponent),
    canActivate: [authGuard]
  },
  { path: 'profile',
    loadComponent: () => import('./users/UI/profile-component/profile-component')
      .then(c => c.ProfileComponent),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {path: '', component: EditProfileComponent, pathMatch: 'full'},
      { path: 'change-password', component: ChangePasswordComponent },
    ]
  },

];
